import script from "./card-body-vote.vue?vue&type=script&setup=true&lang=js"
export * from "./card-body-vote.vue?vue&type=script&setup=true&lang=js"

import "./card-body-vote.vue?vue&type=style&index=0&id=3f7585c8&lang=css"

const __exports__ = script;

export default __exports__